export default function setFormFiles() {
    document.querySelectorAll('[form-file]').forEach(formFileWrapper => {
        const input = formFileWrapper.querySelector('input[type="file"]');
        const dropArea = formFileWrapper.querySelector('.drop-area');
        const messageBox = formFileWrapper.querySelector('.message-box');

        const updateFileList = files => {
            const names = Array.from(files)
                .map(file => file.name)
                .join(', ');
            messageBox.innerHTML = `<span class="text-p-small underline text-text-primary font-medium">${names}</span>`;
        };

        input.addEventListener('change', function () {
            if (input.files.length > 0) {
                updateFileList(input.files);
            }
        });

        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(
                eventName,
                e => {
                    e.preventDefault();
                    e.stopPropagation();
                },
                false
            );
        });

        ['dragenter', 'dragover'].forEach(eventName => {
            dropArea.addEventListener(
                eventName,
                () => dropArea.classList.add('bg-gray-100'),
                false
            );
        });

        ['dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(
                eventName,
                () => dropArea.classList.remove('bg-gray-100'),
                false
            );
        });

        dropArea.addEventListener('drop', function (e) {
            const files = e.dataTransfer.files;
            input.files = files;
            updateFileList(files);
        });
    });
}
